<template>
  <!-- TODO: añade clase colapsed si está colapsado, esto lo vamos a cambiar -->
  <div class="comment-section">
    <span class="advice" v-if="!getIsLogged">
      Para poder comentar
      <a @click.prevent="onClickSubscription" href="#">suscríbete a infoLibre</a>.
      Si ya lo estás <a @click.prevent="onClickLogin" href="#">Inicia sesión</a>
    </span>
    <span class="advice" v-else-if="!getIsUserCommentable">
      Para poder comentar
      <a @click.prevent="onClickSubscription" href="#">suscríbete a infoLibre</a>
    </span>

    <textarea
      cols="30"
      rows="10"
      id="comment-text"
      :value="commentText"
      :disabled="!getIsUserCommentable"
      :placeholder="placeholder"
      v-disable="!getIsUserCommentable"
      @input="change"
      ></textarea>
    <span v-if="getIsUserCommentable" class="advice counter">
      Caracteres restantes:<span :style="hasReachedCharsLimit ? 'color: red' : null">{{ remainingChars }}</span>|{{ maxCharsAllowed }}
    </span>
    <div class="comment-section-buttons">
      <edi-blue-btn
          v-disable="disableCreateComment"
          :disabled="disableCreateComment"
          class="comment-btn"
          @click="click"
      >Comentar</edi-blue-btn>
      <!-- FIXME: esto debería venir como variable de entorno -->
      <a href="/normas-comunidad/." class="terms-of-use">Normas de uso</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EdiCommentMixin from '../mixins';
import { EdiBlueBtn } from '../../components';

const MAX_CHARACTERS_ALLOWED = 2500;

export default {
  name: 'edi-comment-section',
  mixins: [EdiCommentMixin],
  components: {
    EdiBlueBtn,
  },
  props: {
    commentType: Number,
    contentId: Number,
  },
  data() {
    return {
      commentText: '',
    };
  },
  computed: {
    ...mapGetters([
      'isLogged',
      'isPartner',
      'isUserCommentable',
      'replyingUserNick',
    ]),
    getIsLogged() {
      return this.isLogged;
    },
    getIsUserCommentable() {
      return this.isUserCommentable(this.commentType);
    },
    textCharsAmmount() {
      return this.commentText.split('').length;
    },
    remainingChars() {
      return MAX_CHARACTERS_ALLOWED - this.textCharsAmmount;
    },
    maxCharsAllowed() {
      return MAX_CHARACTERS_ALLOWED;
    },
    isEmptyText() {
      return this.textCharsAmmount === 0;
    },
    hasReachedCharsLimit() {
      return this.textCharsAmmount > MAX_CHARACTERS_ALLOWED;
    },
    disableCreateComment() {
      if (!this.isUserCommentable(this.commentType) || this.isEmptyText) {
        return true;
      }
      return this.hasReachedCharsLimit;
    },
    placeholder() {
      if (!this.isLogged) {
        return 'Inicia sesión o suscríbete a infoLibre para comentar';
      }
      if (!this.isUserCommentable(this.commentType)) {
        return 'Suscríbete a infoLibre para comentar';
      }
      if (!this.replyingUserNick) {
        return 'Deja tu comentario';
      }
      return `Respondiendo a @${this.replyingUserNick}`;
    },
  },
  methods: {
    ...mapActions([
      'createComment',
    ]),
    change(evt) {
      this.commentText = evt.target.value;
    },
    click() {
      window.dataLayer.push({
        event: 'comment_interaction',
        eventData: {
          im_action: 'comentar',
          content_id: this.contentId.toString(),
        },
      });
      this.createComment(this.commentText);
      this.commentText = '';
    },
  },
};
</script>
